import { render, staticRenderFns } from "./DesktopShopHome.vue?vue&type=template&id=dae5ecea"
import script from "./DesktopShopHome.vue?vue&type=script&lang=js"
export * from "./DesktopShopHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dae5ecea')) {
      api.createRecord('dae5ecea', component.options)
    } else {
      api.reload('dae5ecea', component.options)
    }
    module.hot.accept("./DesktopShopHome.vue?vue&type=template&id=dae5ecea", function () {
      api.rerender('dae5ecea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/DesktopShopHome.vue"
export default component.exports